<form-control
  [config]="toggleConfig"
  [control]="formGroup.get(config.prop)"
  [group]="formGroup"
>
</form-control>

@if (showDependents) {
  <div @fade>
    <form-group
      [configs]="config.controls"
      [form]="formGroup"
      [ngClass]="{ 'conditional-grid': config.isGrid }"
    >
    </form-group>
  </div>
}
